const getApiUrl = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  if (hostname.includes('loop-site.com')) {
    return 'https://api.loop-site.com:10443';
  }
  
  return 'https://api.loop.college:10443';
};

export const API_URL = getApiUrl();
export default API_URL;